import { render, staticRenderFns } from "./VestingPercentInputs.vue?vue&type=template&id=057718ae&"
import script from "./VestingPercentInputs.vue?vue&type=script&lang=js&"
export * from "./VestingPercentInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports